import React from "react";
import "./Banner.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";
// import { Context } from "../../../utils/context";
import Common_Form from "../../../components/common_components/common_form/Common_Form";

const Specialization_Banner = () => {
  return (
    <section className="specialization-banner" id="home">
      <div className="container-fluid p-0">
        <div className="banner-image course_banner_div">
          <>
            <Swiper
              spaceBetween={30}
              pagination={{ clickable: true }}
              // className="mySwiper"
            >
              <SwiperSlide>
                <img
                  rel="preload"
                  loading="lazy"
                  className="ban-img"
                  width="1920"
                  height="700"
                  src=
                  // "/assets/images/Banner/banner-1.jpg"
                  "/assets/images/Banner/banner.jpg"
                />
              </SwiperSlide>

              <div className="admission_banner mobile_banner">
                <img
                  src="/assets/images/Banner/admission-banner.png"
                  alt="banner"
                  className="admission_img"
                />

                <div className="admission_open_div">
                  <p className="inner_text">Admissions Open Jan-2027</p>
                </div>

              </div>
            </Swiper>

            <div className="form_holder">
              <Common_Form />
            </div>
          </>
        </div>
      </div>

      <div className="eligibility_strip">
        <div className="eligibility_wrapper">
          <span className="eligibility_label">Eligibility</span>
          <span className="eligibility_text">
            Graduate in any discipline, from a recognized University. Min 50%
            for regular and 45% for category students
          </span>
        </div>
      </div>
    </section>
  );
};

export default Specialization_Banner;
